// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3Zgsr","errorLogs":"styles_errorLogs__2Mam2"};